import { endOfDay, format } from 'date-fns';
import { functions } from '../../../firebase';
import { useQuery } from '@tanstack/react-query';

type GPSVelocity = {
  groundSpeed: number;
  heading: number;
};

type GPSVariables = {
  harshAccelerationDigital: boolean;
  harshBrakingDigital: boolean;
  harshCorneringDigital: boolean;
  satelliteCount: number;
  ignition: true;
  movement: true;
  gsmSignalStrength: number;
  cellID: number;
  hdop: number;
  externalVoltage: number;
  batteryVoltage: number;
  batteryCurrent: number;
};

type Track = {
  logTime: string; // date
  gpsId: string;
  velocity: GPSVelocity;
  variables: GPSVariables;
  serverTime: string; // date
  altitude: number;
  lat: number;
  lng: number;
  orgId: string;
};

export default function useTracks({
  orgId,
  sensorId,
  date,
}: {
  orgId: string;
  sensorId: string;
  date: string;
}) {
  const { data, isLoading, error } = useQuery<Track[], Error>({
    queryKey: ['tracks', orgId, sensorId, date],
    queryFn: async () => {
      const functionRef = functions.httpsCallable('settings');
      const response: any = await functionRef({
        requestType: 'GET_GPS_GATE_TRACKS',
        sensorId,
        orgId,
        date,
      });

      const errorCode = response?.data?.httpErrorCode?.status;
      if (errorCode) {
        console.error({ errorCode });
        throw new Error(`Error fetching tracks: ${errorCode}`);
      }
      return response?.data;
    },
    enabled: !!orgId && !!sensorId && !!date,
  });

  return { tracks: data || [], isTrackLoading: isLoading, error };
}
